import { createSlice } from '@reduxjs/toolkit';

/**
 * Backend reachability state for the whole app.
 *
 * `isDown` flips true only after a request failure (network error or 5xx) has
 * been confirmed by a failing `/version/` probe (see monitor.js). The
 * ApiHealthGate reacts to it: it hides the app, polls `/version/`, and does a
 * full page reload once the backend answers again — smoothing over the brief
 * API outage while a tenant backend is redeployed.
 */
const slice = createSlice({
  name: 'apiHealth',
  initialState: { isDown: false },
  reducers: {
    setApiDown: state => {
      state.isDown = true;
    },
    setApiUp: state => {
      state.isDown = false;
    },
  },
});

export const { setApiDown, setApiUp } = slice.actions;

export const selectApiDown = state => state.apiHealth.isDown;

export default slice.reducer;
